module.exports = __webpack_public_path__ + "media/images/black_history_month/vector2-89f3f07a9a468c166b69c6e5036b5d51.svg";